const eventOptions = {
  noise: {
    audio_only: { value: "audio_only", label: "events.audioOnly" },
    audio_photo: { value: "audio_photo", label: "events.audioPhoto" },
    audio_video: { value: "audio_video", label: "events.audioVideo" }
  },
  motion: {
    photo: { value: "photo", label: "photo" },
    video: { value: "video", label: "video" }
  }
};

export default eventOptions;
